import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as ContainerActions from '../_actions/container';
import { Container } from '../_models';

export interface ContainerState extends EntityState<Container> {
  loading: boolean;
  loaded: boolean;
  error: any;
}

export const adapter: EntityAdapter<Container> = createEntityAdapter<Container>();

const initialState: ContainerState = adapter.getInitialState({
  loading: false,
  loaded: false,
  error: null,
});

const containerReducer = createReducer(
  initialState,

  on(ContainerActions.loadContainers, (state) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
  })),

  on(ContainerActions.loadContainersSuccess, (state, { containers }) =>
    adapter.setAll(containers, { ...state, loaded: true, loading: false })
  ),

  on(ContainerActions.loadContainersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    error,
  })),

  on(ContainerActions.addContainerSuccess, (state, { container }) =>
    adapter.addOne(container, state)
  ),

  on(ContainerActions.updateContainerSuccess, (state, { container }) =>
    adapter.upsertOne(container, state)
  ),

  on(ContainerActions.deleteContainerSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    ContainerActions.addContainerFailure,
    ContainerActions.updateContainerFailure,
    ContainerActions.deleteContainerFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: ContainerState | undefined, action: Action) {
  return containerReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
